export default __webpack_public_path__ + "static/media/mail-post.6a866ec2.svg";